import { IBatchLabel, BatchLabelSelection, UpdateBatchLabelRequest } from "../../../../../@types/API/IBatchLabel";
import { BatchFormValueV2 } from "../../../../FormsV2";

type LabelSelection = Pick<BatchFormValueV2, "batchLabel" | "batchStamp">;
type LabelField = "batchLabel" | "batchStamp";

export function getBatchLabelValidation(value: LabelSelection, labels: IBatchLabel[]): Partial<Record<LabelField, string>> {
  if (!value.batchLabel) return {};
  const label = labels.find((item) => item.id === value.batchLabel?.id);
  if (!label) return { batchLabel: "batchLabel.invalidLabel" };

  const errors: Partial<Record<LabelField, string>> = {};
  const allowedStamps = label.stamp_options;
  if (allowedStamps.length && (value.batchStamp == null || !Number.isInteger(value.batchStamp) || !allowedStamps.includes(value.batchStamp))) {
    errors.batchStamp = "batchLabel.stampRequired";
  }
  if (!allowedStamps.length && value.batchStamp != null) errors.batchStamp = "batchLabel.invalidStamp";
  return errors;
}

export function getBatchLabelPayload(value: LabelSelection): BatchLabelSelection {
  return {
    batch_label_id: value.batchLabel?.id ?? null,
    batch_stamp: value.batchLabel ? value.batchStamp ?? null : null,
  };
}

export function getUpdateBatchLabelPayload(id: number, value: LabelSelection): UpdateBatchLabelRequest {
  return { id, ...getBatchLabelPayload(value) };
}
